module.exports = __webpack_public_path__ + "img/75624.e658a44c.svg";